import { useEffect } from 'react'
import { Form } from 'react-bootstrap'

export default function Number(props) {

    const { label_name, placeholder, disabled, name, value, onChange, onBlur, error, form_group, mandatory, readOnly, reference, tabIndex } = props

    useEffect(() => {
        const handleScroll = (event) => {
            event.preventDefault(); // Prevent default scroll behavior
        };

        const inputElements = document.querySelectorAll('input[type="number"]');

        inputElements.forEach((inputElement) => {
            inputElement.addEventListener('wheel', handleScroll, { passive: false });
        });

        return () => {
            inputElements.forEach((inputElement) => {
                inputElement.removeEventListener('wheel', handleScroll);
            });
        };
    }, [])

    return (
        <>
            <Form.Group className={form_group ? form_group : "mb-2"} controlId={name}>
                {label_name === '' ? '' : <Form.Label className={mandatory ? 'form_label_red' : 'form_label'}>{`${label_name}${mandatory ? '*' : ''}`}</Form.Label>}
                <Form.Control
                    ref={reference}
                    type="number"
                    size="sm"
                    placeholder={placeholder}
                    disabled={disabled}
                    readOnly={readOnly}
                    className='form_input'
                    name={name}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    tabIndex={tabIndex}
                />
                {error}
            </Form.Group>
        </>
    )
}
